<div class="aza-horizontal-stack multi-registration__header">
  <div class="multi-registration__header__title">
    {{
        TRANSLATION_MAP.AVAILABLE_SLOTS | translate : {
            assigned_count: (state.max_slots - state.total_unassigned_slots),
            total_count: state.max_slots
        }
    }}
  </div>
  <div
    class="multi-registration__header__info aza-flex-grow"
        [innerHTML]="
            state.can_add_participant
                ? ((config?.unassigned_tickets_allowed
                      ? TRANSLATION_MAP.REMAINING_OPTIONAL_SLOTS_INFO
                      : TRANSLATION_MAP.REMAINING_MANDATORY_SLOTS_INFO
                  )
                  | translate
                      : { unassigned_count: state.total_unassigned_slots }
                  | apply : formSvc.getSanitizedHtml)
                : ''
        "
  ></div>
  @if (
    state
    | apply
    : formSvc.createAssignMainParticipantFieldData
    : config; as fieldData
    ) {
    <div
      #headerAssignMainParticipantEl
      class="{{ attributeName.assignMainParticipantClassName }}"
      >
      <ng-container
        [ngTemplateOutlet]="fieldTemplate"
            [ngTemplateOutletContext]="{
                field: fieldData.field,
                participant: fieldData.data
            }"
      ></ng-container>
      {{
      fieldData.data.status
      | apply
      : recallFillElementOnStatusChanges
      : fieldData.data
      : headerAssignMainParticipantEl
      }}
    </div>
  }
  @if (isOrganizationManager) {
  <div class="multi-registration__header__search-contacts">
    <button class="aza-button aza-flex-grow" (click)="openContactSearchModal()" [disabled]="!state.can_add_participant"
      [class.disabled]="!state.can_add_participant">
      {{ TRANSLATION_MAP.SEARCH | translate }}
    </button>
  </div>
  }
  <div class="multi-registration__header__add-sub-participant">
    <button
      class="aza-button aza-flex-grow"
      (click)="showDraftSubParticipant()"
      [disabled]="!state.can_add_participant"
      [class.disabled]="!state.can_add_participant"
      >
      {{ TRANSLATION_MAP.INVITE_SUB_PARTICIPANTS | translate }}
    </button>
  </div>
</div>

@if (
  editedSubParticipantRecord()[state.main_participant.id] ||
  editedSubParticipantRecord()[
  attributeName.draftParticipantId
  ]; as draftParticipant
  ) {
  <ng-container
    class="multi-registration__new-participant"
    >
    @if (
      (draftParticipant.is_main &&
      !state.main_participant.ticket_type_id) ||
      draftParticipant.id === attributeName.draftParticipantId
      ) {
      <div
        class="multi-registration__new-participant aza-cmp-padding"
        >
        <ng-container
          [ngTemplateOutlet]="subParticipantForm"
          [ngTemplateOutletContext]="{ participant: draftParticipant }"
          >
        </ng-container>
        @if (
          !isRequireTicket &&
          draftParticipant.is_main &&
          draftParticipant.id
          ) {
          <!-- Immediately save draft if its main_participant && multiregistration_type != 'ticket' -->
          {{ draftParticipant.id | apply : saveDraftAfterDelay }}
        }
      </div>
    }
  </ng-container>
}

@if (state.error?.code) {
  <div class="multi-registration__notification notifications-container error" [innerText]="state | apply : getGlobalErrorMessage">
  </div>
}

<aza-rws-multi-registration-form-table
  #tableEl
  [extraRowDivTemplate]="tableExtraRowDiv"
  [rowActionGetter]="tableRowActionGetter"
  [config]="config"
  [eventParticipant]="eventParticipant"
  [state]="state"
  [allParticipantFields]="allParticipantFields"
  [subParticipantFields]="subParticipantFields"
  [editedSubParticipantRecord]="editedSubParticipantRecord()"
  [products]="products"
></aza-rws-multi-registration-form-table>

<ng-template #tableExtraRowDiv let-row="row" let-isCardView="isCardView">
  @if (editedSubParticipantRecord()[row.object.id]; as subParticipant) {
    @if (
      subParticipant.is_main
      ? !!subParticipant.ticket_type_id
      : subParticipant.id !== attributeName.draftParticipantId
      ) {
      <ng-container
        [ngTemplateOutlet]="subParticipantForm"
            [ngTemplateOutletContext]="{
                participant: subParticipant,
                isTableRow: !isCardView
            }"
      ></ng-container>
    }
  }

  @if (
    !editedSubParticipantRecord()[row.object.id] &&
    row.object.ui_participant; as subParticipant
    ) {
    @if (subParticipant?.error?.message; as error) {
      <div class="{{ !isCardView | apply : getVirtualTableRowCss }}">
        @if (isCardView) {
          <div
            class="aza-field-validation-error aza-cmp-padding"
            >
            {{ error }}
          </div>
        }
        @if (!isCardView) {
          <td
            class="aza-field-validation-error aza-cmp-padding"
            [attr.colspan]="tableEl.data$.value.columns.length + 1"
            >
            {{ error }}
          </td>
        }
      </div>
    }
  }
</ng-template>

<ng-template
  #subParticipantForm
  let-participant="participant"
  let-isTableRow="isTableRow"
  >
  <div class="modal-dialogs-container">
    <div aza-rws-modal-dialog-overlay class="modal-dialog-overlay"></div>
    <form>
        <div
            class="{{
                isTableRow | apply : getVirtualTableRowCss
            }} aza-section-content aza-section-colors modal-dialog-centered  {{
                participant.is_main ? 'multi-registration__main-participant' : ''
            }} {{ attributeName.classNamePrefixSubParticipant }}{{
                participant.id
            }} {{ attributeName.classNamePrefixSubParticipant }}status-{{
                participant.status
            }}"
        [attr.sub-participant-id]="participant.id"
        >
        @if (participant; as subParticipant) {
            @if (isTableRow) {
            <td
                class="aza-cmp-padding"
                [attr.colspan]="tableEl.data$.value.columns.length + 1"
                >
                <ng-container
                [ngTemplateOutlet]="fieldAreaWrapperTemplate"
                ></ng-container>
            </td>
            }
            @if (!isTableRow) {
            <ng-container
                [ngTemplateOutlet]="fieldAreaWrapperTemplate"
            ></ng-container>
            }
            <ng-template #fieldAreaWrapperTemplate>
            <div
                #fieldAreaWrapperEl
                class="aza-form-field-area-wrapper"
                [class.aza-cmp-padding]="!isTableRow"
                >
                @if (!subParticipant.is_main) {
                @for (field of subParticipantFields; track field.id) {
                    <ng-container
                    [ngTemplateOutlet]="fieldTemplate"
                                [ngTemplateOutletContext]="{
                                    field:
                                        subParticipant.status
                                        | apply
                                            : getFieldWithParticipantStatus
                                            : field
                                            : subParticipant,
                                    participant: subParticipant
                                }"
                    ></ng-container>
                }
                }
                @if (
                subParticipant
                | apply
                : formSvc.createTicketField
                : products
                : (subParticipant.is_main
                ? true
                : undefined); as field
                ) {
                <ng-container
                    [ngTemplateOutlet]="ticketFieldTemplate"
                    [ngTemplateOutletContext]="{ field, participant: subParticipant}"
                ></ng-container>
                }
                {{
                subParticipant.status
                | apply
                : recallFillElementOnStatusChanges
                : subParticipant
                : fieldAreaWrapperEl
                }}
            </div>
            <div class="aza-padding"></div>
            <div class="aza-horizontal-stack justify-self-end">
                <button
                class="aza-button"
                (click)="cancelDraft(subParticipant.id)"
                >
                {{ TRANSLATION_MAP.CLOSE | translate }}
                </button>
                <button
                #addSubParticipantButtonEL
                class="aza-button"
                            [disabled]="
                                getSaveSubParticipantDisabled(subParticipant.id)
                            "
                            [class.disabled]="
                                getSaveSubParticipantDisabled(subParticipant.id)
                            "
                (click)="saveDraft(subParticipant.id)"
                >
                {{
                (isTableRow
                ? TRANSLATION_MAP.EDIT_SUB_PARTICIPANTS
                : TRANSLATION_MAP.ADD_SUB_PARTICIPANTS
                ) | translate
                }}
                </button>
            </div>
            </ng-template>
        }
        </div>
    </form>
  </div>
</ng-template>

<ng-template
  #fieldTemplate
  let-field="field"
  let-participant="participant"
  let-validateFnName="validateFnName"
  >
  <div
    #formFieldAreaDiv
    class="aza-form-field-area"
    [attr.aza-input-lock-value]="field.editable ? null : true"
        [innerHtml]="
            null
                | apply
                    : formSvc.createInputFieldElement
                    : field
                    : participant
                    : validateFnName
        "
  ></div>
  {{ field | apply : setSelectFieldOptionsAfterDelay : formFieldAreaDiv : participant | async}}
</ng-template>

<ng-template
  #ticketFieldTemplate
  let-field="field"
  let-participant="participant"
  >
  @if (isRequireTicket) {
    <ng-container
      [ngTemplateOutlet]="fieldTemplate"
      [ngTemplateOutletContext]="{ field, participant, validateFnName: 'azavista.validateMultiRegistrationTicketField' }"
    ></ng-container>
  }
  <ng-container
    [ngTemplateOutlet]="addonsFieldTemplate"
    [ngTemplateOutletContext]="{ participant, ticketId: editedSubParticipantRecord()[participant.id]?.ticket_type_id}"
  ></ng-container>
</ng-template>

<ng-template
  #addonsFieldTemplate
  let-participant="participant"
  let-ticketId="ticketId"
  >
  @let addons = ticketId | apply : formSvc.getParticipantAddons : { participantId: participant.id };
  @if (addons?.length) {
    @let field = addons | apply : formSvc.createAddonsField;
    @if (field) {
      <ng-container
        [ngTemplateOutlet]="fieldTemplate"
        [ngTemplateOutletContext]="{ field, participant }"
      ></ng-container>
    }
  }
</ng-template>

@if (showContactSearchModal) {
  <aza-rws-search-contacts-dialog
    [workflowId]="config?.workflow_id!"
    [subParticipantFields]="subParticipantFields"
    [subParticipantFieldIds]="subParticipantFieldIds"
    [subParticipantEmailField]="subParticipantEmailField"
    [state]="state"
    (closeDialog)="closeContactSearchModal()"
    (saveSelection)="onContactsSave($event)"
  />
}
